import animateScrollTo from 'animated-scroll-to';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Plyr from 'plyr';
import GLightbox from 'glightbox';
import '../scss/index.scss';
import '../images/sprite.svg';
import '../images/social.png';
import '../media/announce.mp4';

gsap.registerEffect({
    name: "counter",
    extendTimeline: true,
    defaults: {
        end: 0,
        duration: 4,
        ease: "power3",
        increment: 1,
    },
    effect: (targets, config) => {
        let tl = gsap.timeline()
        let num = targets[0].innerText.replace(/\,/g,'')
        targets[0].innerText = num;
        tl.to(targets, {
                duration: config.duration, 
                innerText: config.end, 
                modifiers: {
                    innerText: function(innerText) {
                        return gsap.utils.snap(config.increment, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                },
                ease: config.ease
            }, 0);
        return tl
    }
})

const app = (function(){
    const loadedClass = 'loaded',
        $loader = document.querySelector('.site-loader'),
        $header = document.querySelector('.site-header'),
        headerHeight = $header.clientHeight,
        $nav = document.querySelector('.site-nav'),
        $navBtn = $nav.querySelector('.site-nav__btn'),
        scrollBtns = document.querySelectorAll('.site-nav__list a, .btn_scroll'),
        navActiveClass = 'site-nav_active',
        $shareToggle = document.querySelector('.share-toggle'),
        shareToggleActiveClass = 'share-toggle_active',
        mqLg = window.matchMedia('(min-width: 992px)'),
        mqMd = window.matchMedia('(min-width: 768px)'),
        glightbox = GLightbox();

    glightbox.on('slide_after_load', (data) => {
        const { slideIndex, slideNode, slideConfig, player, trigger } = data;
        const video = slideNode.querySelector('video');
        if (video && !video.hasAttribute('playsinline')) {
            video.setAttribute('playsinline', '');
        }
    });

    function handlePageLoad() {
        document.querySelector('body').classList.add(loadedClass);
        setTimeout(() => {
            $loader.style.display = 'none';
        }, 1000);
    }
    
    function handleNavBtnClick() {
        $navBtn.addEventListener('click', () => {
            $nav.classList.contains(navActiveClass) ? $nav.classList.remove(navActiveClass) : $nav.classList.add(navActiveClass);
        });
    }

    function handleScrollBtnClick() {
        scrollBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const target = e.currentTarget.getAttribute('href');
                $nav.classList.remove(navActiveClass);
                
                e.preventDefault();
                animateScrollTo(document.querySelector(target), {
                    verticalOffset: -headerHeight
                });
            });
        });
    }

    function handleShareToggleClick() {
        let shareToggleBtn = $shareToggle.querySelector('.share-toggle__btn');
        shareToggleBtn.addEventListener('click', (e) => {
            $shareToggle.classList.toggle(shareToggleActiveClass);
        });
    }

    function initScrollAnimations() {
        ScrollTrigger.create({
            trigger: $header,
            start: "top top",
            end: 99999,
            toggleClass: "site-header_sticky"
        });

        function animateFrom(elem) {
            const animatedElems = elem.querySelectorAll('.reveal');
            elem.classList.add('section_visible');
            animatedElems.forEach(el => {
                const animation = el.dataset.animation;
                el.classList.add(animation);
            });
        }

        gsap.utils.toArray(".section").forEach(function(elem, index) {
            const $heading = elem.querySelector('.heading_scrolling');

            if ($heading) {
                const $mask = $heading.querySelector('.heading__inner');
                const [x, xEnd] = ['100%', '-40%'];
                gsap.fromTo($mask, { x }, {
                    x: xEnd,
                    scrollTrigger: { 
                        trigger: elem, 
                        scrub: 1
                    }
                });
            }

            ScrollTrigger.create({
                trigger: elem,
                start: "top 60%",
                once: true,
                onEnter: function() { animateFrom(elem) }
            });
        });
    }

    function initShare() {
        const shareBtns = document.querySelectorAll('.share');
        shareBtns.forEach((buttons) => {
            let share = Ya.share2(buttons, {
                theme: {
                    services: 'vkontakte,odnoklassniki,facebook,twitter'
                }
            });
        });
    }

    function initVideo() {
        const videos = document.querySelectorAll('.video');
        videos.forEach(video => {
            const $playBtn = video.querySelector('.video__play');
            $playBtn.addEventListener('click', () => {
                video.classList.add('video_active');
                const player = new Plyr(video.querySelector('video'), {
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen']
                });
                player.play();
            });
        });
    }

    function initSliders() {
        Swiper.use([Navigation, Pagination, Autoplay]);

        const $sliderBaiting = document.querySelector('.slider_baiting'),
            $sliderStandup = document.querySelector('.slider_standup'),
            $sliderStats = document.querySelector('.slider_stats'),
            $sliderCyberbullying = document.querySelector('.slider_cyberbullying'),
            sliderVideo = document.querySelectorAll('.slider_video');

        let lightbox_baiting,
            lightbox_standup,
            sliderStats,
            sliderCyberbullying;
        
        const sliderBaiting = new Swiper($sliderBaiting, {
            loop: true,
            navigation: {
                nextEl: '.slider_baiting .swiper-button-next',
                prevEl: '.slider_baiting .swiper-button-prev'
            },
            speed: 500,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 1.3,
                    spaceBetween: 30
                },
                1200: {
                    slidesPerView: 1,
                    spaceBetween: 292
                }
            },
            on: {
                init: function () {
                    lightbox_baiting = GLightbox({
                        selector: '.glightbox_baiting'
                    });
                }
            }
        });

        const sliderStandup = new Swiper($sliderStandup, {
            loop: true,
            navigation: {
                nextEl: '.slider_standup .swiper-button-next',
                prevEl: '.slider_standup .swiper-button-prev'
            },
            pagination: {
                el: '.slider_standup .swiper-pagination',
                type: 'fraction',
            },
            speed: 500,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 1.3
                }
            },
            on: {
                init: function () {
                    lightbox_standup = GLightbox({
                        selector: '.glightbox_standup'
                    });
                }
            }
        });

        sliderVideo.forEach($slider => {
            const $prevBtn = $slider.parentNode.querySelector('.swiper-button-prev'),
                $nextBtn = $slider.parentNode.querySelector('.swiper-button-next');
            new Swiper($slider, {
                loop: true,
                navigation: {
                    nextEl: $nextBtn,
                    prevEl: $prevBtn
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 20
                    },
                    1400: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                },
                on: {
                    init: function () {
                        lightbox_standup = GLightbox({
                            selector: '.glightbox_standup'
                        });
                    }
                }
            }); 
        })

        const handleWidthMdChange = e => {
            if (e.matches) {
                if (sliderCyberbullying) {
                    sliderCyberbullying.destroy();
                }
            } else {
                sliderCyberbullying = new Swiper($sliderCyberbullying, {
                    navigation: {
                        nextEl: '.slider_cyberbullying .swiper-button-next',
                        prevEl: '.slider_cyberbullying .swiper-button-prev'
                    },
                    slidesPerView: 1
                });
            }
        };

        if (mqMd.addEventListener) {
            mqMd.addEventListener('change', handleWidthMdChange);
        } else {
            mqMd.addListener(handleWidthMdChange);
        }
        handleWidthMdChange(mqMd);

        const handleWidthLgChange = e => {
            if (e.matches) {
                if (sliderStats) {
                    sliderStats.destroy();
                }
            } else {
                sliderStats = new Swiper($sliderStats, {
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        }
                    }
                });
            }
        };

        if (mqLg.addEventListener) {
            mqLg.addEventListener('change', handleWidthLgChange);
        } else {
            mqLg.addListener(handleWidthLgChange);
        }
        handleWidthLgChange(mqLg);
    }

    function initStorySlider() {
        const $sliderStars = document.querySelector('.slider_stars');

        let lightbox_stars;
        
        const sliderStars = new Swiper($sliderStars, {
            loop: true,
            loopAdditionalSlides: 1,
            navigation: {
                nextEl: '.slider_stars .swiper-button-next',
                prevEl: '.slider_stars .swiper-button-prev'
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2.3,
                    spaceBetween: 40
                },
                1400: {
                    slidesPerView: 'auto',
                    spaceBetween: 186,
                    centeredSlides: true
                }
            },
            on: {
                init: function () {
                    lightbox_stars = GLightbox({
                        selector: '.glightbox_stars'
                    });
                }
            }
        });
    }

    function initCounters() {
        const counters = document.querySelectorAll('.stats__value span');
        counters.forEach(counter => {
            const value = parseInt(counter.dataset.value);
            gsap.effects.counter(counter, {end: value});
        });
    }

    function setContent() {
        const contentBlocks = document.querySelectorAll('.content');

        async function getContentData(el, id) {
            try {
                const url = isDev ? `${id}.json` : `https://www.m24.ru/api/v2?type=back&id=${id}&format=json`;
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('данные бэка не получены');
                }
                const data = await response.json();
                el.innerHTML = data[0].html;
                if (id == 459) {
                    initStorySlider();
                }
            } catch (error) {
                console.log('Возникла проблема с получением данных: ', error.message);
            }
        }

        contentBlocks.forEach(block => {
            const backID = block.dataset.backId;
            getContentData(block, backID);
        });

    }
   
    function init() {
        gsap.registerPlugin(ScrollTrigger);

        handlePageLoad();
        handleNavBtnClick();
        handleScrollBtnClick();
        handleShareToggleClick();
        initScrollAnimations();
        initShare();
        initVideo();
        initSliders();
        initCounters();
        setContent()
    }

    return {
        init: init
    }
}());

function ready(fn) {
    if (document.readyState != 'loading'){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(app.init);